export const DEFAULT_COUNTLY_VERSION = '1.1.21'

/**
 * 拼接参数到url
 * @param baseUrl
 * @param params
 * @returns
 */
export function appendParamsToUrl(baseUrl: string, params: Record<string, any>): string {
  // 创建一个 URLSearchParams 对象
  const searchParams = new URLSearchParams()

  // 遍历对象，将每个键值对添加到 searchParams
  for (const [key, value] of Object.entries(params)) {
    searchParams.append(key, value.toString())
  }

  // 获取查询字符串
  const queryString = searchParams.toString()

  // 如果 baseUrl 已经有查询参数，使用 &，否则使用 ?
  const separator = baseUrl.includes('?') ? '&' : '?'

  // 将查询字符串附加到 baseUrl
  return queryString ? `${baseUrl}${separator}${queryString}` : baseUrl
}

/**
 * 生成countly scripts
 * @param nameList
 * @param appKeyList
 * @param version
 * @returns
 */
export function appenCountlyScript({
  nameList,
  appKeyList,
  version,
  serverUrl,
  appKeyWithHost = [],
}: {
  nameList: string[]
  appKeyList: string[]
  version: string
  serverUrl?: string
  appKeyWithHost?: string[][]
}) {
  if (!appKeyWithHost.length && nameList.length !== appKeyList.length) {
    throw new Error('name和appKey的数组长度不一致')
  }

  const injectCountlyScripts: string[] = []

  nameList.forEach((itemName, index) => {
    injectCountlyScripts.push(
      `<script src="https://dep176.gsf.netease.com/hubble-to-countly/${version}/js-sdk/assets/cly.min.js"></script>`
    )

    injectCountlyScripts.push(`<script>
      (function () {
        window['${itemName}'] = Object.assign({}, Countly || {}, {
          q: []
        });

        // 这里添加 是为了每次不修改初始化的Countly 兼容多实例的场景
        if (!Countly.i) {
          Countly.i = {};
        }

        var appKeyWithHost = JSON.parse('${JSON.stringify(appKeyWithHost || '[]')}')

        // 根据域名取app_key
        var regexMatchItem = appKeyWithHost && appKeyWithHost.length > 0 && appKeyWithHost.find(function (item) {
          return new RegExp(item[1], "g").test(location.host)
        })
        
        if (regexMatchItem) {
          window['${itemName}'].app_key = regexMatchItem[0];
        } else if ('${appKeyList[index]}') {
          window['${itemName}'].app_key = '${appKeyList[index]}';
        }
        
        if (window['${itemName}'].app_key) {
          window['${itemName}'].url = '${serverUrl || 'https://countly.unus.netease.com'}';
        
          // 必须要接收init的返回值，否则还是原来的countly
          window['${itemName}'] = window['${itemName}'].init(window['${itemName}'])
        } else {
          delete window['${itemName}']
        }
      })()
      </script>`)
  })

  return injectCountlyScripts
}

/**
 *
 * @param pageviewOptions
 * @param version
 * @returns
 */
export function generateInjectCountly(props: {
  pageviewOptions: Record<string, string>,
  version: string,
  name: string,
  pageviewWaitUserDetails?: boolean,
  pageviewDebounce?: number,
  debug?: boolean
}) {
  const { pageviewOptions, version, name, pageviewWaitUserDetails = false, pageviewDebounce, debug = false } = props

  const params: Record<string, any> = {
    ...pageviewOptions,
    name,
  }
  if (pageviewWaitUserDetails) {
    params.pageviewWaitUserDetails = pageviewWaitUserDetails
  }
  if (pageviewDebounce !== undefined) {
    params.pageviewDebounce = pageviewDebounce
  }
  if (debug) {
    params.debug = debug
  }

  return `<script src="${appendParamsToUrl(
    `https://dep176.gsf.netease.com/hubble-to-countly/${version}/js-sdk/assets/pageview.min.js`,
    params
  )}"></script>`
}

/**
 *
 * @param appKey
 * @param hubbleInitOptions
 * @returns
 */
export function appendHubbleScript(appKey: string, hubbleInitOptions: Record<string, any>, version: string) {
  return [
    `<script>
          (function(document,datracker,root){function loadJsSDK(){var script,first_script;script=document.createElement('script');script.type='text/javascript';script.async=true;script.src='https://dep176.gsf.netease.com/hubble-to-countly/${version}/js-sdk/assets/index.min.js';first_script=document.getElementsByTagName('script')[0];first_script.parentNode.insertBefore(script,first_script);}if(!datracker['__SV']){var win=window;var gen_fn,functions,i,lib_name='DATracker';window[lib_name]=datracker;datracker['_i']=[];datracker['init']=function(token,config,name){var target=datracker;if(typeof name!=='undefined'){target=datracker[name]=[];}else{name=lib_name;}target['people']=target['people']||[];target['toString']=function(no_stub){var str=lib_name;if(name!==lib_name){str+='.'+name;}if(!no_stub){str+=' (stub)';}return str;};target['people']['toString']=function(){return target.toString(1)+'.people (stub)';};function _set_and_defer(target,fn){var split=fn.split('.');if(split.length==2){target=target[split[0]];fn=split[1];}target[fn]=function(){target.push([fn].concat(Array.prototype.slice.call(arguments,0)));};}functions='get_user_id track_heatmap register_attributes register_attributes_once clear_attributes unregister_attributes current_attributes single_pageview disable time_event get_appStatus track set_userId track_pageview track_links track_forms register register_once alias unregister identify login logout signup name_tag set_config reset people.set people.set_once people.set_realname people.set_country people.set_province people.set_city people.set_age people.set_gender people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.set_populationWithAccount people.set_location people.set_birthday people.set_region people.set_account'.split(' ');for(i=0;i<functions.length;i++){_set_and_defer(target,functions[i]);}datracker['_i'].push([token,config,name]);};datracker['__SV']=1.0;loadJsSDK();}})(document,window['DATracker']||[],window);
        </script>`,
    `<script>
          DATracker.init(
            '${appKey}',
            ${JSON.stringify(hubbleInitOptions)}
          )
        </script>`,
  ]
}
